import { IdPropType } from '../../../proptypes/basic';


const LocationAgencyDatevId = ({ agency_datev_id }) => {
  return agency_datev_id ? agency_datev_id : '-';
};

LocationAgencyDatevId.propTypes = {
    agency_datev_id: IdPropType.isRequired,
};

export default LocationAgencyDatevId;